module.exports = __webpack_public_path__ + "img/airklima-rz-ipad.081eb153.png";